import { IComponentOptions } from "angular";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";

interface SingleGoalSelectorMetricsListBindings {
  metrics: Metric[];
  unselectableId: string;
  select(args: { metric: Metric }): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SingleGoalSelectorMetricsListCtrl extends SingleGoalSelectorMetricsListBindings {}
class SingleGoalSelectorMetricsListCtrl {}

export const SingleGoalSelectorMetricsListComponent: IComponentOptions = {
  template: require("./single-goal-selector-metrics-list.component.html"),
  controller: SingleGoalSelectorMetricsListCtrl,
  bindings: {
    metrics: "<",
    unselectableId: "<",
    select: "&",
  },
};
